import React, { useState, useEffect, useContext } from "react";
import { getDomains } from "../api/domains";
import { getGeoApi } from "../api/geo";
import { getTenantsForUser } from "../api/users";
import { getTenant } from "../api/tenants";
import GisApi from "../api/gisApi"
import rolesList from "./roles";

const DEFAULT_REDIRECT_CALLBACK = () =>
  window.history.replaceState({}, document.title, window.location.pathname);

export const Auth0Context = React.createContext();
export const useAuth0 = () => useContext(Auth0Context);

export const Auth0Provider = ({
  children,
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  auth0ClientInstance,
  eventBus
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState();
  const [user, setUser] = useState();
  const [auth0Client, setAuth0] = useState();
  const [loading, setLoading] = useState(true);
  const [domains, setDomains] = useState();
  const [associatedTenants, setAssociatedTenants] = useState();
  const [activeTenant, setActiveTenant] = useState();
  const [geo, setGeo] = useState();
  const [popupOpen, setPopupOpen] = useState(false);
  const [gisApi, setGisApi] = useState(false)


  const getActiveTenant = async (userTenants = []) => {
    const activeId = localStorage.getItem("activeTenant");
    const active = userTenants.find(el => el._id === activeId);

    if (active) {
      return active;
    }

    if (userTenants && userTenants.length) {
      return userTenants[0];
    }

    /* if (!activeId) {
      return userTenants[0];
    } */

    if (activeId) {
      return await getTenant(activeId);
    }

    return null;
  };

  const changeActiveTenant = active => {
    const activeId = active ? active._id || "" : "";
    localStorage.setItem("activeTenant", activeId);
    setActiveTenant(active || null);
  };

  const isForbiddenAgentAsSeller = (roles, userRole, presentTenant) => {
    if (!roles) return false;
    if (roles.includes(rolesList.VENDITORE)) return false;
    if (!presentTenant) return false;
    if (presentTenant.type !== rolesList.VENDITORE) return false;
    return userRole === rolesList.AGENTE;
  }

  const isAgentAsSeller = (userRole, presentTenant) => {
    return (presentTenant && presentTenant.type === rolesList.VENDITORE && userRole === rolesList.AGENTE)
  }

  useEffect(() => {
    const initAuth0 = async () => {
      setAuth0(auth0ClientInstance);
      if (window.location.search.includes("code=")) {
        const { appState } = await auth0ClientInstance.handleRedirectCallback();
        onRedirectCallback(appState);
      }

      const isAuthenticated = await auth0ClientInstance.isAuthenticated();

      setIsAuthenticated(isAuthenticated);

      if (isAuthenticated) {
        const user = await auth0ClientInstance.getUser();
        const domainsData = await getDomains();
        const geoApi = getGeoApi(domainsData.comuni.comuni);
        const tenants = await getTenantsForUser();

        user.isInRole = (roles, presentTenant) => {
          if (!roles || !roles.length || roles === "*") return true;

          const meta = user["https://piramis.com/user_metadata"] || {};
          const userRole = meta.role;

          try {
            if (presentTenant.type && userRole !== "admin") {
              const hasRole = roles.indexOf(presentTenant.type) >= 0;
              return hasRole;
            }
          } catch (e) {
            null;
          }

          if (roles.includes("AGENT-AS-SELLER") && isAgentAsSeller(userRole, presentTenant)) {
            return true;
          }
          const hasRole = roles.indexOf(userRole) >= 0;
          return hasRole && !isForbiddenAgentAsSeller(roles, userRole, presentTenant);
        };

        user.getRole = () => {
          const meta = user["https://piramis.com/user_metadata"] || {};
          const userId = meta.piramisid || "";
          localStorage.setItem("activeUser", userId);
          return meta.role;
        };

        setGisApi(new GisApi(domainsData.appSettings))
        setUser(user);
        setDomains(domainsData);
        setAssociatedTenants(tenants);
        changeActiveTenant(await getActiveTenant(tenants));
        setGeo(geoApi);
      }

      setLoading(false);
    };
    initAuth0();
    // eslint-disable-next-line
  }, []);

  const loginWithPopup = async (params = {}) => {
    setPopupOpen(true);
    try {
      await auth0Client.loginWithPopup(params);
    } catch (error) {
      console.error(error);
    } finally {
      setPopupOpen(false);
    }
    const user = await auth0Client.getUser();
    setUser(user);
    setIsAuthenticated(true);
  };

  const onError = () => {
    eventBus.dispatchEvent(
      new CustomEvent("growl", {
        detail: {
          message: {
            type: "error",
            summary: "Errore Applicativo",
            content: "Si é verificato un errore. Si prega di riprovare."
          }
        }
      })
    );
  };

  const onSuccess = () => {
    eventBus.dispatchEvent(
      new CustomEvent("growl", {
        detail: {
          message: {
            type: "success",
            summary: "Operazione conclusa con successo",
            content: "L'operazione richiesta si è conclusa con successo ."
          }
        }
      })
    );
  };

  const handleRedirectCallback = async () => {
    setLoading(true);
    await auth0Client.handleRedirectCallback();
    const user = await auth0Client.getUser();
    setLoading(false);
    setIsAuthenticated(true);
    setUser(user);
  };
  return (
    <Auth0Context.Provider
      value={{
        isAuthenticated,
        gisApi,
        user,
        domains,
        geo,
        loading,
        associatedTenants,
        popupOpen,
        loginWithPopup,
        onSuccess,
        onError,
        eventBus,
        changeActiveTenant,
        activeTenant,
        handleRedirectCallback,
        getIdTokenClaims: (...p) => auth0Client.getIdTokenClaims(...p),
        loginWithRedirect: (...p) => auth0Client.loginWithRedirect(...p),
        getTokenSilently: (...p) => auth0Client.getTokenSilently(...p),
        getTokenWithPopup: (...p) => auth0Client.getTokenWithPopup(...p),
        logout: (...p) => auth0Client.logout(...p)
      }}
    >
      {children}
    </Auth0Context.Provider>
  );
};
